<template>
  <v-row class="body">
    <v-col class="pa-13" align="center" cols="12" md="5" xl="3" lg="4" sm="12" xs="12">
      <v-form  ref="form">
        <!-- <strong style="font-size: 38px; color: #fff">Synergy</strong> -->
       
        <v-card flat class="card mt-5 pa-8">
          <div><img style="width: 6rem" class="mb-5" :src="require('../../public/logo.png')" alt="" /></div>
          <img :src="require('@/assets/Group24.svg')" alt="wjk" />

          <v-card-title class="LoginTitle">Check your email</v-card-title>
          <span class="text-body-2 text-disabled font-weight-bold"
            >We have sent a password reset link to {{ Email }}</span
          >

          <v-card-text class="pa-0 my-4 pt-2">
            Didn’t receive the email ? <a @click="resend()" class="resend" style="color: rgb(104, 104, 246) ;">Click to resend</a>
          </v-card-text>
          <v-card-action>
            <span @click="this.$router.push('/')" style="cursor: pointer;" class="text-body back-btn  text-disabled font-weight-medium">
              <v-icon  class="resend ">mdi-arrow-left</v-icon
              >&nbsp;&nbsp;Back to log in</span
            >
          </v-card-action>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
// import userService from "../api/service/UserService.js"
import ResetPasswordService from "@/api/service/ResetPasswordService";
export default {
  components: {},
  data() {
    return {
      Email: this.$route.query.email,
    };
  },
  methods: {
    async resend() {
      try {
        let data = JSON.parse(localStorage.getItem("PASSWORD_DATA"));
        localStorage.setItem("PASSWORD_DATA", JSON.stringify(data));
        await ResetPasswordService.forgotPassword(data);
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
  },
};
</script>

<style>
.resend {
  cursor: pointer;
}
.resend:hover ,.back-btn:hover {
  color: rgb(104, 104, 246) !important;
  cursor: pointer;
}
</style>
